export const LIQUIDS = {
  WATER: 'Вода',
  PROPYLENE_GLYCOL: 'Пропиленгликоль',
  ETHYLENE_GLYCOL: 'Этиленгликоль',
};
